/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ImportExportCountry } from '../enums/import-export-country.enum';
import { CaseDocumentType } from '../enums/case-document-type.enum';
import { TransportType } from '../enums/transport-type.enum';
import { ClearanceCaseStatus } from '../enums/clearance-case-status.enum';

//<custom-head>
import { IconUtils } from 'app/utils';
//</custom-head>

export class CaseUserBarItemDto {
  public clearanceCaseId: string = undefined;
  public caseDocumentId: string = undefined;
  public importCountry: ImportExportCountry;
  public exportCountry: ImportExportCountry;
  public documentType: CaseDocumentType;
  public ecomCaseNumber: string = undefined;
  public senderName: string = undefined;
  public receiverName: string = undefined;
  public invoiced: boolean;
  public transportType: TransportType;
  public latestUtc: Date | string;
  public modificationsUtc: Date[];
  public clearanceCaseStatus: ClearanceCaseStatus;

  //<custom-body>
  constructor(source:CaseUserBarItemDto){
      Object.assign(this,source)
    }
  
    public get transportIcon(): string {
      return IconUtils.transportIcon(this.transportType);
    }
  
    public get documentIcon(): string {
      return IconUtils.transportIcon(this.transportType);
    }
  
    public get icon(): string {
      if(!!this.clearanceCaseId)
      return this.transportIcon;
  
      if(!!this.caseDocumentId)
      return this.documentIcon;
  
      return'';
    }
  
    public get documentTypeTranslation(){
      switch(this.documentType)
      {
        case CaseDocumentType.RegistrationCard:
        return 'cases.documents.registrationCard';
        case CaseDocumentType.Delivery:
        return 'cases.documents.delivery';
        case CaseDocumentType.Eur1:
        return 'cases.documents.eur1';
        case CaseDocumentType.T2L:
        return 'cases.documents.t2l';
        case CaseDocumentType.OtherInvoicing:
        return 'cases.documents.otherInvoicing';
        case CaseDocumentType.AdditionalHandling:
        return 'cases.documents.additionalHandling';
      }
      return ''
    }
  //</custom-body>
}
